// Thin re-export shim. The implementation lives in `./address-input/index.tsx`
// (broken into types/use-places/view/index sub-modules so it stays
// maintainable). External callers continue to import from
// `@kit/artists` without churn.
//
// New API:
//   <AddressInput name="address" required onAutocompleteError={...} />
//   <AddressInput name="address" mode="view" />
//
// The component reads value/onChange/errors from `useFormContext()` —
// callers must render it inside a `<FormProvider>`.
export {
  AddressInput,
  AddressSchema,
  ADDRESS_AUTOCOMPLETE_COUNTRIES,
  PLACES_CALLBACK_TIMEOUT_MS,
  PLACES_FAIL_OPEN_AFTER_CONSECUTIVE_TIMEOUTS,
  type AddressInfo,
  type AddressValue,
} from './address-input/index';

export type {
  AddressFieldError,
  AddressInputProps,
} from './address-input/types';

// Legacy type alias retained for any downstream consumer that imports
// `AddressData` from this module path. New code should prefer
// `AddressValue` (or `AddressInfo` if reading from the schema).
export type { AddressValue as AddressData } from './address-input/types';
